import React, {Component} from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';
import commaNumber from 'comma-number';
import {fetchPayletterResult} from '../../../actions/payment.actions';
import {formatLocalDateToYYYYMMDD, formatUtcDateToLocalDateFormat} from '../../../util/timeUtils';
import {Button, ButtonGroup, Table} from '../../Common/PageComponents';
const stateToProps = state => {
  return {
    paymentResult: state.payment.paymentResult,
  };
};

class PayletterResult extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    let requestParams = queryString.parse(window.location.search);
    this.props.dispatch(fetchPayletterResult(requestParams.clientparam));
  }

  _close() {
    window.close();
  }

  _paymentSuccess() {
    return (
      <div id="paymentSuccess" className="popbod">
        <div className="payment-result-title">구매가 완료되었습니다.</div>
        <Table theme={'form'}>
          <colgroup>
            <col width={128} />
            <col width="*" />
          </colgroup>
          <tbody>
            <tr>
              <th>거래번호</th>
              <td>
                <label id="ctl00_ContentPlaceHolder1_orderno">{this.props.paymentResult.productEntitlementId}</label>
              </td>
            </tr>
            <tr>
              <th>결제일</th>
              <td>
                <label id="ctl00_ContentPlaceHolder1_paydate">
                  {formatLocalDateToYYYYMMDD(this.props.paymentResult.paidAt)}
                </label>
              </td>
            </tr>
            <tr>
              <th>결제수단</th>
              <td>
                <label id="ctl00_ContentPlaceHolder1_paytool">{this.props.paymentResult.payletterPg.name}</label>
              </td>
            </tr>
            <tr>
              <th>결제금액</th>
              <td>
                <label id="ctl00_ContentPlaceHolder1_amt">{commaNumber(this.props.paymentResult.price)}</label>원
              </td>
            </tr>
          </tbody>
        </Table>
        <ButtonGroup style={{marginTop: '20px'}}>
          <Button theme={'gray'} onClick={() => this._close()}>
            확인
          </Button>
        </ButtonGroup>
      </div>
    );
  }

  _virtualAccount() {
    return (
      <div id="virtualAccount" className="popbod">
        <div className="payment-result-title">가상계좌결제</div>
        <Table>
          <colgroup>
            <col width={160} />
            <col width="*" />
          </colgroup>
          <tbody>
            <tr>
              <th>이체은행</th>
              <td>
                <label id="ctl00_ContentPlaceHolder1_bankname">{this.props.paymentResult.virtualAccountBankName}</label>
              </td>
            </tr>
            <tr>
              <th>가상계좌번호</th>
              <td>
                <label id="ctl00_ContentPlaceHolder1_accountno">{this.props.paymentResult.virtualAccountNumber}</label>
              </td>
            </tr>
            <tr>
              <th>가상계좌 예금주명</th>
              <td>{this.props.paymentResult.virtualAccountHolder}</td>
            </tr>
            <tr>
              <th>결제금액</th>
              <td>
                <label id="ctl00_ContentPlaceHolder1_payamt">{commaNumber(this.props.paymentResult.price)}</label> 원
              </td>
            </tr>
            <tr>
              <th>상품명</th>
              <td>
                <label id="ctl00_ContentPlaceHolder1_hours">{this.props.paymentResult.productName}</label>
              </td>
            </tr>
            <tr>
              <th>가상계좌 유효일자</th>
              <td>{formatUtcDateToLocalDateFormat(this.props.paymentResult.virtualAccountDueDate)} 까지</td>
            </tr>
          </tbody>
        </Table>
        <ButtonGroup style={{marginTop: '20px'}}>
          <Button theme={'gray'} onClick={() => this._close()}>
            확인
          </Button>
        </ButtonGroup>
      </div>
    );
  }

  _paymentFail() {
    return (
      <div id="paymentFail" className="popbod">
        <div className="payment-result-title">결제 진행 중 오류가 발생했습니다.</div>
        <Table>
          <colgroup>
            <col width={128} />
            <col width="*" />
          </colgroup>
          <tbody>
            <tr>
              <th>오류코드</th>
              <td>
                <label id="errcode" runat="server" />
              </td>
            </tr>
            <tr>
              <th>오류내용</th>
              <td>
                <label id="errmsg" runat="server" style={{color: 'Red'}} />
                {this.props.paymentResult.errorMessage}
              </td>
            </tr>
          </tbody>
        </Table>
        <ButtonGroup style={{marginTop: '20px'}}>
          <Button theme={'gray'} onClick={() => this._close()}>
            확인
          </Button>
        </ButtonGroup>
      </div>
    );
  }

  render() {
    if (!this.props.paymentResult) {
      return null;
    }
    window.resizeTo(500, 600);

    let popBody;
    if (this.props.paymentResult.success) {
      if (this.props.paymentResult.paymentType === 'VIRTUAL_ACCOUNT') {
        popBody = this._virtualAccount();
      } else {
        popBody = this._paymentSuccess();
      }
    } else {
      popBody = this._paymentFail();
    }

    return (
      <div id="paymentResult">
        <div id="pophead">
          <h1>프리미엄 PC방 결제창</h1>
          <span alt="닫기" onClick={() => this._close()}>
            X
          </span>
        </div>
        {popBody}
      </div>
    );
  }
}

export default connect(stateToProps)(PayletterResult);
